module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Scale-9e18dc550d98339139e346b9d872cc943af371dc2529c1d20ef97d34586e5c46.svg";